import React, { Component } from "react";
import {
  Map,
  GoogleApiWrapper,
  Marker,
  Polyline,
  InfoWindow,
} from "google-maps-react";
import LocalizedStrings from "react-localization";
import { auth, fire } from "../../firebase/index";
import { FormControl } from "react-bootstrap";
import { customLog, style } from "../../variables/Variables";
import _, { each, method } from "lodash";
import TimeStamp from "react-timestamp";
import {
  TableHeaderColumn,
  BootstrapTable,
  SearchField,
} from "react-bootstrap-table";
import { Modal, Button } from "react-bootstrap";
import mapMarker from "../../assets/img/map_marker.png";
import mapMarkerUnlocked from "../../assets/img/map_marker_unlocked.png";
import mapMarkerLocked from "../../assets/img/map_marker_locked.png";
import { Checkbox } from "material-ui";
import EditTrip from "./edit_trip";
import NotificationSystem from "react-notification-system";
import { confirmAlert } from "react-confirm-alert";

let localizationStrings = new LocalizedStrings({
  en: {
    superadmindropdownLabel: "Select Lock Admin :",
    dropdownLabel: "Select your Lock Serial :",
    superadmindropdownTitle: "-Select Lock Admin-",
    showAllTitle: "Show All",
    dropdownTitle: "-Select your Lock Serial-",
    dateTimeHeader: "Date Time",
    userEmailHeader: "User Email",
    noDataTitle: "There is no data to display",
    memberManagementHeader: "All Members",
    recipientManagementHeader: "My Recipient List",
    groupManagementHeader: "My Group List",
    pastTripsHeader: "Past Trips",
    completedTripsHeader: "Completed Trips",
    tripLabel: "Trip ",
    lockSelectedLabel: "Selected Locks: ",
    startDateLabel: "Start: ",
    endDateLabel: "End: ",
    dateTimeHeader: "Date & Time",
    plannedScheduleHeader: "Planned Schedule",
    locksHeader: "Locks",
    locationsHeader: "Locations",
    locationsLabel: "Location: ",
    noTripsLabel: "No trips found",
    detailedInfo: "View Detailed Information",
    detailedInfoHeader: "Detailed Information",
    additionalInfo: "View Additional Information",
    additionalInfoHeader: "Additional Information",
    unlockInfoHeader: "Unlock Information",
    tripInfoHeader: "Trip Information",
    tripName: "Trip Name:",
    plannedSchedule: "Planned Schedule:",
    realizedSchedule: "Realized Schedule:",
    locks: "Locks:",
    locations: "Locations:",
    lockUnlocked: "Lock Unlocked:",
    unlockedBy: "Unlocked By:",
    unlockedOn: "Unlocked On:",
    unlockLocation: "Unlock Location:",
    location: "Location:",
    lock: "Lock:",
    unlockPointHeader: "Unlock Point",
    lockActivityHeader: "Lock Activity",
    proofOfCompletion: "Proof of Completion",
    locationHeader: "Location",
    openInNewTab: "Open in New Tab",
    downloadImage: "Download Image",
    destinationPointHeader: "Destination Point",
    statusLabel: "Status:",
    remarksLabel: "Remarks:",
    destinationInfoHeader: "Destination Information",
    inactiveTripsHeader: "Inactive Trips",
    editTripBtn: "Edit Trip",
    changesSaved: "Changes have been saved successfully",
    changesNotSaved:
      "An error occurred while saving the changes. Please try again.",
    beginTripBtn: "Begin Trip",
    tripStarted:
      "The trip has started. You can view the details in the 'Active Trips' tab.",
    tripNotStarted:
      "An error occurred while starting the trip. Please try again.",
    searchPlaceholder: "Search",
    removeSelected: "Remove Selected",
    confirmBtn: "Confirm",
    cancelBtn: "Cancel",
    tripRemovalLabel: "Trip Removal",
    tripRemovalMsg:
      "Are you sure? Selected trips and all their data will be permanently removed from the system.",
    tripsRemoved: "Selected trips have been removed successfully",
    pendingArrivalStatus: "Pending Arrival",
    skippedStatus: "Skipped",
    completedStatus: "Completed",
    lockedStatus: "LOCKED",
    unlockedStatus: "UNLOCKED",
    tripNameHeader: "Trip Name",
    PICHeader: "Person In Charge",
    trackedLocksHeader: "Tracked Locks",
    schedStartHeader: "Scheduled Start",
    schedEndHeader: "Scheduled End",
    editTripHeader: "Edit Trip",
    beginTripHeader: "Begin Trip",
    locationInfoBtn: "View Locations Info",
    locationAddressHeader: "Location/Address",
    statusHeader: "Status",
    remarksHeader: "Remarks",
    proofHeader: "Proof of Completion",
    noProofLabel: "No Proof Provided",
    viewProofBtn: "View Proof Image",
  },
  ja: {
    superadmindropdownLabel: "ロック管理者を選択:",
    dropdownLabel: "ロックのシリアル番号を選択:",
    superadmindropdownTitle: "-ロック管理者を選択-",
    showAllTitle: "すべて表示",
    dropdownTitle: "-ロックのシリアル番号を選択-",
    dateTimeHeader: "日付と時刻",
    userEmailHeader: "ユーザーのメールアドレス",
    noDataTitle: "表示するデータがありません",
    memberManagementHeader: "全メンバー",
    recipientManagementHeader: "自分の受取人リスト",
    groupManagementHeader: "自分のグループリスト",
    pastTripsHeader: "過去のトリップ",
    completedTripsHeader: "完了したトリップ",
    tripLabel: "トリップ ",
    lockSelectedLabel: "選択されたロック: ",
    startDateLabel: "開始: ",
    endDateLabel: "終了: ",
    dateTimeHeader: "日付と時刻",
    plannedScheduleHeader: "予定スケジュール",
    locksHeader: "ロック",
    locationsHeader: "場所",
    locationsLabel: "場所: ",
    noTripsLabel: "トリップは見つかりませんでした",
    detailedInfo: "詳細情報を見る",
    detailedInfoHeader: "詳細情報",
    additionalInfo: "追加情報を見る",
    additionalInfoHeader: "追加情報",
    unlockInfoHeader: "ロック解除情報",
    tripInfoHeader: "トリップ情報",
    tripName: "トリップ名:",
    plannedSchedule: "計画されたスケジュール:",
    realizedSchedule: "実行されたスケジュール:",
    locks: "ロック:",
    locations: "場所:",
    lockUnlocked: "ロック解除:",
    unlockedBy: "解除した人:",
    unlockedOn: "解除日:",
    unlockLocation: "解除場所:",
    location: "場所:",
    lock: "ロック:",
    unlockPointHeader: "アンロックポイント",
    lockActivityHeader: "ロックアクティビティ",
    proofOfCompletion: "完了確認写真",
    locationHeader: "場所",
    openInNewTab: "新しいタブで開く",
    downloadImage: "画像をダウンロード",
    destinationPointHeader: "目的地",
    statusLabel: "ステータス:",
    remarksLabel: "備考:",
    destinationInfoHeader: "目的地情報",
    inactiveTripsHeader: "非アクティブなトリップ",
    editTripBtn: "トリップを編集",
    changesSaved: "変更は正常に保存されました",
    changesNotSaved:
      "変更の保存中にエラーが発生しました。もう一度試してください。",
    beginTripBtn: "トリップを始める",
    tripStarted:
      "トリップ始まりました。詳細は「アクティブなトリップ」タブで確認できます。",
    tripNotStarted:
      "トリップの開始中にエラーが発生しました。もう一度試してください。",
    searchPlaceholder: "検索",
    removeSelected: "削除",
    confirmBtn: "確認する",
    cancelBtn: "キャンセル",
    tripRemovalLabel: "トリップの削除",
    tripRemovalMsg:
      "本気ですか？選択したトリップとそのすべてのデータはシステムから永久に削除されます。",
    tripsRemoved: "選択したトリップが正常に削除されました",
    pendingArrivalStatus: "到着待ち",
    skippedStatus: "スキップされました",
    completedStatus: "完了",
    lockedStatus: "ロックされています",
    unlockedStatus: "ロック解除済み",
    tripNameHeader: "トリップ名",
    PICHeader: "責任者",
    trackedLocksHeader: "追跡されたロック",
    schedStartHeader: "予定開始",
    schedEndHeader: "予定終了",
    editTripHeader: "トリップを編集",
    beginTripHeader: "トリップを開始",
    locationInfoBtn: "場所の情報を表示する",
    locationAddressHeader: "所在地・住所",
    statusHeader: "ステータス",
    remarksHeader: "備考",
    proofHeader: "完了証明書",
    noProofLabel: "証拠は提供されていない",
    viewProofBtn: "証拠画像を見る",
  },
  es: {
    superadmindropdownLabel: "Seleccionar Administrador de la Candado:",
    dropdownLabel: "Seleccionar el Número de Serie de tu Candado:",
    superadmindropdownTitle: "-Seleccionar Administrador de la Candado-",
    showAllTitle: "Mostrar Todo",
    dropdownTitle: "-Seleccionar el Número de Serie de tu Candado-",
    dateTimeHeader: "Fecha y Hora",
    userEmailHeader: "Correo Electrónico del Usuario",
    noDataTitle: "No hay datos para mostrar",
    memberManagementHeader: "Todos los Miembros",
    recipientManagementHeader: "Mi Lista de Destinatarios",
    groupManagementHeader: "Mi Lista de Grupos",
    pastTripsHeader: "Viajes Pasados",
    completedTripsHeader: "Viajes Completados",
    tripLabel: "Viaje ",
    lockSelectedLabel: "Candados Seleccionadas: ",
    startDateLabel: "Inicio: ",
    endDateLabel: "Fin: ",
    dateTimeHeader: "Fecha y Hora",
    plannedScheduleHeader: "Horario Planificado",
    locksHeader: "Candados",
    locationsHeader: "Ubicaciones",
    locationsLabel: "Ubicación: ",
    noTripsLabel: "No se encontraron viajes",
    detailedInfo: "Ver Información Detallada",
    detailedInfoHeader: "Información Detallada",
    additionalInfo: "Ver Información Adicional",
    additionalInfoHeader: "Información Adicional",
    unlockInfoHeader: "Desbloquear Información",
    tripInfoHeader: "Información de Viaje",
    tripName: "Nombre del Viaje:",
    plannedSchedule: "Horario Planificado:",
    realizedSchedule: "Horario Realizado:",
    locks: "Candados:",
    locations: "Ubicaciones:",
    lockUnlocked: "Candado Desbloqueado:",
    unlockedBy: "Desbloqueado Por:",
    unlockedOn: "Desbloqueado En:",
    unlockLocation: "Ubicación de Desbloqueo:",
    location: "Ubicación:",
    lock: "Candado:",
    unlockPointHeader: "Punto de Desbloqueo",
    lockActivityHeader: "Actividad del Candado",
    proofOfCompletion: "Prueba de Entrega",
    locationHeader: "Ubicación",
    openInNewTab: "Abrir en Nueva Pestaña",
    downloadImage: "Descargar Imagen",
    destinationPointHeader: "Punto de Destino",
    statusLabel: "Estatus:",
    remarksLabel: "Observaciones:",
    destinationInfoHeader: "Información de Destino",
    inactiveTripsHeader: "Viajes Inactivos",
    editTripBtn: "Editar Viaje",
    changesSaved: "Los cambios se han guardado correctamente",
    changesNotSaved:
      "Se produjo un error al guardar los cambios. Por favor inténtalo de nuevo.",
    beginTripBtn: "Comenzar Viaje",
    tripStarted:
      "El viaje ha comenzado. Puede ver los detalles en la pestaña 'Viajes Activos'.",
    tripNotStarted:
      "Se produjo un error al iniciar el viaje. Por favor inténtalo de nuevo.",
    searchPlaceholder: "Buscar",
    removeSelected: "Eliminar Seleccion",
    confirmBtn: "Confirmar",
    cancelBtn: "Cancelar",
    tripRemovalLabel: "Eliminación de Viaje",
    tripRemovalMsg:
      "¿Está seguro? Los viajes seleccionados y todos sus datos serán eliminados permanentemente del sistema.",
    tripsRemoved: "Los viajes seleccionados se han eliminado correctamente",
    pendingArrivalStatus: "Pendiente de llegada",
    skippedStatus: "Saltado",
    completedStatus: "Terminado",
    lockedStatus: "BLOQUEADO",
    unlockedStatus: "DESBLOQUEADO",
    tripNameHeader: "Nombre del Viaje",
    PICHeader: "Persona a Cargo",
    trackedLocksHeader: "Candados con Seguimiento",
    schedStartHeader: "Inicio Programado",
    schedEndHeader: "Fin Programado",
    editTripHeader: "Editar Viaje",
    beginTripHeader: "Comenzar Viaje",
    locationInfoBtn: "Ver Info de Ubicaciones",
    locationAddressHeader: "Ubicación/Dirección",
    statusHeader: "Estatus",
    remarksHeader: "Observaciones",
    proofHeader: "Prueba de Finalización",
    noProofLabel: "No se Proporcionó Prueba",
    viewProofBtn: "Ver Imagen de Prueba",
  },
});

class MapViewSection extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedLock: [],
      memberemaillistArray: [],
      polylinePaths: [],
      locationName: "",
      locationList: [],
      lockNames: [],
      userTrips: [],
      activeTrips: [],
      selectedTripId: null,
      markers: [],
      selectedTripDetails: null,
      currentLanguage: "",
      showModal: false,
      showMarkerModal: false,
      showMarkerModal2: false,
      showLocationsModal: false,
      showLockActivityModal: false,
      showProofModal: false,
      selectedMarker: null,
      selectedMarker2: null,
      mapZoom: 12,
      showingUnlockInfoWindow: false,
      showingLocationInfoWindow: false,
      activeMarker: {},
      selectedPlace: {},
      liveCoordinates: [],
      livePolylinePaths: [],
      lockActivity: [],
      locationsData: [],
      editTripId: null,
      showEditModal: false,
      _notificationSystem: null,
      tripsSelected: [],
    };
  }

  componentWillMount() {
    auth.onAuthStateChanged((user) => {
      if (user) {
        // User is signed in.
        this.setState({
          currentUserUID: user.uid,
          loading: false,
        });

        if (this.state.currentUserUID !== "") {
          fire
            .database()
            .ref("userSettings")
            .child(this.state.currentUserUID) // get uid from auth person object
            .child("language")
            .on("value", this._langCb = (snapshot) => {
              customLog(snapshot.val());
              if (snapshot.val() === null) {
                fire
                  .database()
                  .ref("userSettings")
                  .child(this.state.currentUserUID)
                  .child("language")
                  .set("en");

                this.setState({
                  currentLanguage: localizationStrings.getLanguage(),
                });
                customLog(this.state.currentLanguage);
              } else {
                this.setState({
                  currentLanguage: snapshot.val(),
                });
              }
            });
        } else {
          customLog("NOTHING IS CALLED");
        }
        // console.log(user.uid)
      } else {
        // No user is signed in.
        customLog("Not Signed In");
      }
    });
  }

  onLocationNameChange = (e) => {
    this.setState({ locationName: e.target.value });
  };

  onFindLocation = () => {
    const { locationName } = this.state;
    const { google } = this.props;

    const geocoder = new google.maps.Geocoder();

    geocoder.geocode({ address: locationName }, (results, status) => {
      if (status === "OK" && results[0]) {
        const { lat, lng } = results[0].geometry.location;
        const newMarker = { lat: lat(), lng: lng() };
        const updatedMarkers = [...this.state.markers, newMarker];

        this.setState((prevState) => ({
          markers: updatedMarkers,
          locationList: [...prevState.locationList, locationName],
        }));

        if (updatedMarkers.length > 1) {
          this.updatePolylinePaths(updatedMarkers, this.state.polylinePaths);
        }
      } else {
        console.error(
          "Geocode was not successful for the following reason: " + status
        );
      }
    });
  };

  togglePlotting = () => {
    this.setState((prevState) => ({
      isPlotting: !prevState.isPlotting,
      markers: [],
      polylinePaths: [],
      livePolylinePaths: [],
    }));
  };

  fetchUserTrips = () => {
    const database = fire.database();
    const userId = auth.currentUser.uid;
    const tripsRef = database.ref(`activeTrip/${userId}`);

    tripsRef.on("value", (snapshot) => {
      const userTrips = snapshot.val();
      if (userTrips) {
        const tripsArray = Object.keys(userTrips).map((tripId) => ({
          tripId,
          ...userTrips[tripId],
        }));

        const activeTrips = tripsArray.filter(
          (trip) => trip.Status === "Inactive"
        );
        this.setState({ activeTrips });
        console.log("Active Trips:", activeTrips);
      } else {
        console.log("No trips found for the user");
      }
    });
  };

  Triptracking = (selectedTripId, locations) => {
    const database = fire.database();

    const selectedTrip = this.state.activeTrips.find(
      (trip) => trip.tripId === selectedTripId
    );

    if (!selectedTrip) {
      console.log("Selected trip not found.");
      return;
    }

    const startTime = new Date(selectedTrip.datestart).getTime();
    const endTime = new Date(selectedTrip.endDate).getTime();

    const coordinatesArray = [];
    const lockActivityArray = [];

    const promises = this.state.activeTrips
      .find((trip) => trip.tripId === this.state.selectedTripId)
      .lockSelected.map(async (lock) => {
        return database
          .ref("AuditTrail")
          .child(lock.ip45SerialNumber)
          .once("value")
          .then((snapshot) => {
            const data = snapshot.val();

            if (data) {
              Object.keys(data).forEach((key) => {
                const timestamp = data[key].time;
                const date = new Date(timestamp);
                const date2 = date.getTime();

                if (
                  date2 > startTime &&
                  date2 < endTime &&
                  data[key].lockedStatus === "UNLOCKED"
                ) {
                  lockActivityArray.push({ ...data[key], lock: lock.Name });
                  coordinatesArray.push({
                    lat: data[key].Latitude,
                    lng: data[key].Longitude,
                  });
                  this.addMarkerForUnlock(
                    data[key].Latitude,
                    data[key].Longitude,
                    data[key],
                    lock
                  );
                  console.log({
                    id: key,
                    ...data[key],
                    readableDate: date.toString(),
                    readableDate2: date2,
                  });
                } else if (
                  date2 > startTime &&
                  date2 < endTime &&
                  data[key].lockedStatus === "LOCKED"
                ) {
                  lockActivityArray.push({ ...data[key], lock: lock.Name });
                }
              });
              this.setState({
                lockActivity: lockActivityArray.sort((a, b) => a.time - b.time),
              });
            }
          })
          .catch((error) => {
            console.error("Error fetching data:", error);
          });
      });

    Promise.all(promises).then(() => {
      this.setState({
        mapCenter: this.calculateMidPoint(locations, coordinatesArray),
        mapZoom: this.calculateSuitableMapZoom(locations, coordinatesArray),
      });
    });
  };

  handleTripClick = (tripId, locations, liveRoute) => {
    // this.removeMarkers();
    // this.setState(
    //   (prevState) => ({
    //     selectedTripId: prevState.selectedTripId === tripId ? null : tripId,
    //   }),
    //   () => {
    //     if (this.state.selectedTripId === tripId) {
    this.Triptracking(tripId, locations);
    locations.forEach((location, index) => {
      this.addMarkerWithId(
        location.lat,
        location.lng,
        `${tripId}-${index}`,
        location.name,
        location
      );
    });
    if (liveRoute) {
      liveRoute.forEach((coordinates) => {
        this.addLiveRouteCoordinate(coordinates.lat, coordinates.lng);
      });
    }
    this.setState({
      mapCenter: this.calculateMidPoint(locations, []),
      mapZoom: this.calculateSuitableMapZoom(locations, []),
      locationsData: locations,
    });
    //     } else {
    //       this.removeMarkers();
    //     }
    //   }
    // );
  };

  componentDidMount() {
    this.fetchUserTrips();
    this.setState({ _notificationSystem: this.refs.notificationSystem });
  }

  addLiveRouteCoordinate = (lat, lng) => {
    const { liveCoordinates } = this.state;
    const newCoordinate = {
      lat: lat,
      lng: lng,
    };

    this.setState(
      (prevState) => ({
        liveCoordinates: [...prevState.liveCoordinates, newCoordinate],
      }),
      () => {
        this.updateLivePolylinePaths(this.state.liveCoordinates);
      }
    );
  };

  addMarkerForUnlock = (lat, lng, data, lock) => {
    const { markers } = this.state;
    const newMarker = {
      position: { lat, lng },
      icon: {
        url: mapMarkerUnlocked,
      },
      // title: "Click for information",
      class: "unlockMarker",
      data: data,
      lock: lock,
    };

    this.setState(
      (prevState) => ({
        markers: [...prevState.markers, newMarker],
      }),
      () => {
        // Any additional functionality after adding the marker
      }
    );
  };

  addMarkerForLock = (lat, lng, data, lock) => {
    const { markers } = this.state;
    const newMarker = {
      position: { lat, lng },
      icon: {
        url: mapMarkerLocked,
      },
      // title: "Click for more info",
      class: "lockMarker",
      data: data,
      lock: lock,
    };

    this.setState(
      (prevState) => ({
        markers: [...prevState.markers, newMarker],
      }),
      () => {
        // Any additional functionality after adding the marker
      }
    );
  };

  addMarkerWithId = (lat, lng, markerId, locationName, data) => {
    const { markers } = this.state;
    const newMarker = {
      id: markerId,
      position: { lat, lng },
      // title: `Marker ${markerId}`,
      // title: `${locationName}`,
      icon: {
        url: mapMarker,
      },
      class: "locationMarker",
      location: locationName,
      data: data,
    };

    this.setState(
      (prevState) => ({
        markers: [...prevState.markers, newMarker],
      }),
      () => {
        this.updatePolylinePaths(this.state.markers);
      }
    );
  };

  updateLivePolylinePaths = (coordinates) => {
    const { google } = this.props;
    const directionsService = new google.maps.DirectionsService();
    const paths = [];

    for (let i = 0; i < coordinates.length - 1; i++) {
      const origin = new google.maps.LatLng(
        coordinates[i].lat,
        coordinates[i].lng
      );
      const destination = new google.maps.LatLng(
        coordinates[i + 1].lat,
        coordinates[i + 1].lng
      );

      directionsService.route(
        {
          origin,
          destination,
          travelMode: google.maps.TravelMode.DRIVING,
        },
        (response, status) => {
          if (status === "OK") {
            const route = response.routes[0].overview_path;
            paths.push(route);

            if (paths.length === coordinates.length - 1) {
              this.setState({ livePolylinePaths: paths });
            }
          } else {
            console.error("Directions request failed due to " + status);
          }
        }
      );
    }
  };

  updatePolylinePaths = (markers) => {
    const { google } = this.props;
    const directionsService = new google.maps.DirectionsService();
    const paths = [];

    for (let i = 0; i < markers.length - 1; i++) {
      const origin = new google.maps.LatLng(
        markers[i].position.lat,
        markers[i].position.lng
      );
      const destination = new google.maps.LatLng(
        markers[i + 1].position.lat,
        markers[i + 1].position.lng
      );

      directionsService.route(
        {
          origin,
          destination,
          travelMode: google.maps.TravelMode.DRIVING,
        },
        (response, status) => {
          if (status === "OK") {
            const route = response.routes[0].overview_path;
            paths.push(route);

            if (paths.length === markers.length - 1) {
              this.setState({ polylinePaths: paths });
            }
          } else {
            console.error("Directions request failed due to " + status);
          }
        }
      );
    }
  };

  removeMarkers = () => {
    const { markers, polylinePaths, livePolylinePaths } = this.state;
    const { google } = this.props;

    markers.forEach((marker) => {
      if (marker && marker.setMap) {
        marker.setMap(null);
      }
    });

    polylinePaths.forEach((path) => {
      if (path && path.setMap) {
        path.setMap(null);
      }
    });

    livePolylinePaths.forEach((path) => {
      if (path && path.setMap) {
        path.setMap(null);
      }
    });

    this.setState({
      markers: [],
      polylinePaths: [],
      liveCoordinates: [],
      livePolylinePaths: [],
      lockActivity: [],
      locationsData: [],
    });
  };

  formatDate = (dateString) => {
    const date = new Date(dateString);

    const dateOptions = {
      weekday: "long",
      day: "2-digit",
      month: "short",
      year: "numeric",
    };
    const timeOptions = { hour: "2-digit", minute: "2-digit", hour12: true };

    let formattedDate = date.toLocaleDateString("en-US", dateOptions);

    formattedDate = formattedDate.replace(/(\w{3} \d{2})(,)/, "$1");

    const formattedTime = date.toLocaleTimeString("en-US", timeOptions);

    const timezoneOffset = -date.getTimezoneOffset();
    const hoursOffset = Math.floor(timezoneOffset / 60);
    const minutesOffset = timezoneOffset % 60;

    const timezoneString = `GMT${hoursOffset >= 0 ? "+" : ""}${hoursOffset}${
      minutesOffset !== 0
        ? `:${String(Math.abs(minutesOffset)).padStart(2, "0")}`
        : ""
    }`;

    return `${formattedDate}, ${formattedTime} ${timezoneString}`;
  };

  formatUnixTimestampDate = (timestamp) => {
    if (!timestamp) return "";

    const date = new Date(timestamp * 1000);

    const dateOptions = {
      weekday: "long",
      day: "2-digit",
      month: "short",
      year: "numeric",
    };
    const timeOptions = { hour: "2-digit", minute: "2-digit", hour12: true };

    let formattedDate = date.toLocaleDateString("en-US", dateOptions);

    formattedDate = formattedDate.replace(/(\w{3} \d{2})(,)/, "$1");

    const formattedTime = date.toLocaleTimeString("en-US", timeOptions);

    const timezoneOffset = -date.getTimezoneOffset();
    const hoursOffset = Math.floor(timezoneOffset / 60);
    const minutesOffset = timezoneOffset % 60;

    const timezoneString = `GMT${hoursOffset >= 0 ? "+" : ""}${hoursOffset}${
      minutesOffset !== 0
        ? `:${String(Math.abs(minutesOffset)).padStart(2, "0")}`
        : ""
    }`;

    return `${formattedDate}, ${formattedTime} ${timezoneString}`;
  };

  calculateMidPoint = (locations, unlockLocations) => {
    let minLat = 90;
    let minLng = 180;
    let maxLat = -90;
    let maxLng = -180;
    let midLat = 0;
    let midLng = 0;
    const locationCount = locations.length + unlockLocations.length;

    if (locationCount === 1) {
      locations.forEach((location) => {
        midLat = location.lat;
        midLng = location.lng;
      });

      return {
        lat: midLat,
        lng: midLng,
      };
    } else {
      locations.forEach((location) => {
        if (location.lat > maxLat) {
          maxLat = location.lat;
        }
        if (location.lat < minLat) {
          minLat = location.lat;
        }
        if (location.lng > maxLng) {
          maxLng = location.lng;
        }
        if (location.lng < minLng) {
          minLng = location.lng;
        }
      });

      unlockLocations.forEach((marker) => {
        if (marker.lat > maxLat) {
          maxLat = marker.lat;
        }
        if (marker.lat < minLat) {
          minLat = marker.lat;
        }
        if (marker.lng > maxLng) {
          maxLng = marker.lng;
        }
        if (marker.lng < minLng) {
          minLng = marker.lng;
        }
      });

      midLat = (maxLat + minLat) / 2;
      midLng = (maxLng + minLng) / 2;

      return {
        lat: midLat,
        lng: midLng,
      };
    }
  };

  calculateSuitableMapZoom = (locations, unlockLocations) => {
    let minLat = 90;
    let minLng = 180;
    let maxLat = -90;
    let maxLng = -180;
    let latDiff = 0;
    let lngDiff = 0;
    let diff = 0;
    const locationCount = locations.length + unlockLocations.length;

    if (locationCount === 1) {
      return 12;
    } else {
      locations.forEach((location) => {
        if (location.lat > maxLat) {
          maxLat = location.lat;
        }
        if (location.lat < minLat) {
          minLat = location.lat;
        }
        if (location.lng > maxLng) {
          maxLng = location.lng;
        }
        if (location.lng < minLng) {
          minLng = location.lng;
        }
      });

      unlockLocations.forEach((marker) => {
        if (marker.lat > maxLat) {
          maxLat = marker.lat;
        }
        if (marker.lat < minLat) {
          minLat = marker.lat;
        }
        if (marker.lng > maxLng) {
          maxLng = marker.lng;
        }
        if (marker.lng < minLng) {
          minLng = marker.lng;
        }
      });

      latDiff = maxLat - minLat;
      lngDiff = maxLng - minLng;

      if (latDiff === lngDiff || latDiff > lngDiff) {
        diff = latDiff;
      } else if (latDiff < lngDiff) {
        diff = lngDiff;
      }

      if (diff <= 0.15) {
        return 12;
      } else if (diff > 0.15 && diff <= 0.3) {
        return 11;
      } else if (diff > 0.3 && diff <= 0.6) {
        return 10;
      } else if (diff > 0.6 && diff <= 1.2) {
        return 9;
      } else if (diff > 1.2 && diff <= 2.4) {
        return 8;
      } else if (diff > 2.4 && diff <= 4.8) {
        return 7;
      } else if (diff > 4.8 && diff <= 9.6) {
        return 6;
      } else if (diff > 9.6 && diff <= 19.2) {
        return 5;
      } else if (diff > 19.2 && diff <= 38.4) {
        return 4;
      } else if (diff > 38.4 && diff <= 76.8) {
        return 3;
      } else if (diff > 76.8 && diff <= 153.6) {
        return 2;
      } else {
        return 1;
      }
    }
  };

  handleMarkerClick = (marker) => {
    if (marker.class === "unlockMarker") {
      this.setState({ selectedMarker: marker });
      this.handleShowMarkerModal();
    } else if (marker.class === "locationMarker") {
      this.setState({ selectedMarker2: marker });
      this.handleShowMarkerModal2();
    }
  };

  handleShowModal = () => {
    this.setState({ showModal: true });
  };

  handleCloseModal = () => {
    this.setState({ showModal: false });
  };

  handleShowMarkerModal = () => {
    this.setState({ showMarkerModal: true });
  };

  handleShowMarkerModal2 = () => {
    this.setState({ showMarkerModal2: true });
  };

  handleCloseMarkerModal = () => {
    this.setState({
      showMarkerModal: false,
      showMarkerModal2: false,
      selectedMarker: null,
      selectedMarker2: null,
    });
  };

  onMarkerHover = (markerData, markerInstance, e) => {
    if (markerData.class === "unlockMarker") {
      this.setState({
        showingUnlockInfoWindow: true,
        activeMarker: markerInstance,
        selectedPlace: markerData,
      });
    } else if (markerData.class === "locationMarker") {
      this.setState({
        showingLocationInfoWindow: true,
        activeMarker: markerInstance,
        selectedPlace: markerData,
      });
    }
  };

  onMarkerHoverOut = () => {
    this.setState({
      showingUnlockInfoWindow: false,
      showingLocationInfoWindow: false,
      activeMarker: {},
    });
  };

  displayTrackedLocks = (locks) => {
    return locks.map((lock) => lock.Name).join(", ");
  };

  formatDisplayDate = (date) => {
    const d = new Date(date);

    const day = d.getDate();
    const month = d.toLocaleString("en-US", { month: "short" });
    const year = d.getFullYear();

    const hours = d.getHours();
    const minutes = d
      .getMinutes()
      .toString()
      .padStart(2, "0");
    const period = hours >= 12 ? "PM" : "AM";
    const formattedHour = hours % 12 || 12;

    return `${day} ${month} ${year}, ${formattedHour}:${minutes}${period}`;
  };

  formatUnixTimestampDisplayDate = (timestamp) => {
    const isSeconds = timestamp < 1e12;
    const d = new Date(isSeconds ? timestamp * 1000 : timestamp);

    const day = d.getDate();
    const month = d.toLocaleString("en-US", { month: "short" });
    const year = d.getFullYear();

    const hours = d.getHours();
    const minutes = d
      .getMinutes()
      .toString()
      .padStart(2, "0");
    const period = hours >= 12 ? "PM" : "AM";
    const formattedHour = hours % 12 || 12;

    return `${day} ${month} ${year}, ${formattedHour}:${minutes}${period}`;
  };

  renderLocationsButton = (tripId) => {
    return (
      <button
        style={{
          width: "100%",
          background: "transparent",
          color: "#1DC7EA",
          border: "1.5px solid #1DC7EA",
          borderRadius: "100px",
          padding: "10px 0",
        }}
        onClick={() => this.handleShowLocationsModal(tripId)}
      >
        {localizationStrings.locationInfoBtn}
      </button>
    );
  };

  handleShowLocationsModal = (tripId) => {
    this.setState(
      {
        showLocationsModal: true,
        selectedTripId: tripId,
      },
      () => {
        const trip = this.state.activeTrips.find(
          (trip) => trip.tripId === tripId
        );
        this.handleTripClick(trip.tripId, trip.locations, trip.liveRoute);
      }
    );
  };

  handleCloseLocationsModal = () => {
    this.removeMarkers();
    this.setState({
      showLocationsModal: false,
      selectedTripId: null,
      lockActivity: [],
      locationsData: [],
    });
  };

  renderLockActivityButton = (tripId) => {
    return (
      <button
        style={{
          width: "100%",
          background: "transparent",
          color: "#1DC7EA",
          border: "1.5px solid #1DC7EA",
          borderRadius: "100px",
          padding: "10px 0",
        }}
        onClick={() => this.handleShowLockActivityModal(tripId)}
      >
        View Lock Activity
      </button>
    );
  };

  handleShowLockActivityModal = (tripId) => {
    this.setState(
      {
        showLockActivityModal: true,
        selectedTripId: tripId,
      },
      () => {
        const trip = this.state.activeTrips.find(
          (trip) => trip.tripId === tripId
        );
        this.handleTripClick(trip.tripId, trip.locations, trip.liveRoute);
      }
    );
  };

  handleCloseLockActivityModal = () => {
    this.removeMarkers();
    this.setState({
      showLockActivityModal: false,
      selectedTripId: null,
      lockActivity: [],
      locationsData: [],
    });
  };

  displayStatus = (status) => {
    if (status === "Completed") {
      return (
        <p style={{ color: "green", fontSize: "14px", margin: "0" }}>
          {localizationStrings.completedStatus}
        </p>
      );
    } else if (status === "Pending Arrival") {
      return (
        <p style={{ color: "red", fontSize: "14px", margin: "0" }}>
          {localizationStrings.pendingArrivalStatus}
        </p>
      );
    } else if (status === "Skipped") {
      return (
        <p style={{ color: "orange", fontSize: "14px", margin: "0" }}>
          {localizationStrings.skippedStatus}
        </p>
      );
    } else if (status === "UNLOCKED") {
      return (
        <p style={{ color: "green", fontSize: "14px", margin: "0" }}>
          {localizationStrings.unlockedStatus}
        </p>
      );
    } else if (status === "LOCKED") {
      return (
        <p style={{ color: "red", fontSize: "14px", margin: "0" }}>
          {localizationStrings.lockedStatus}
        </p>
      );
    } else {
      return (
        <p style={{ color: "black", fontSize: "14px", margin: "0" }}>
          {status}
        </p>
      );
    }
  };

  displayProof = (proof) => {
    if (proof === undefined || proof === null || proof === "-") {
      return (
        <button
          style={{
            width: "100%",
            background: "transparent",
            color: "lightgrey",
            border: "1.5px solid lightgrey",
            borderRadius: "100px",
            padding: "10px 0",
          }}
          disabled={true}
        >
          {localizationStrings.noProofLabel}
        </button>
      );
    } else {
      return (
        <button
          style={{
            width: "100%",
            background: "transparent",
            color: "#1DC7EA",
            border: "1.5px solid #1DC7EA",
            borderRadius: "100px",
            padding: "10px 0",
          }}
          onClick={() => this.handleShowProofModal(proof)}
        >
          {localizationStrings.viewProofBtn}
        </button>
      );
    }
  };

  handleShowProofModal = (proof) => {
    const storageRef = fire.storage().ref();
    const imageRef = storageRef.child("ATProofImages/" + proof);
    imageRef
      .getDownloadURL()
      .then((url) => {
        document.getElementById("proofImage").src = url;
        document.getElementById("proofNewTab").onclick = () => {
          const a = document.createElement("a");
          a.href = url;
          a.target = "_blank";
          a.click();
        };
        document.getElementById("proofDownload").onclick = () => {
          const xhr = new XMLHttpRequest();
          xhr.responseType = "blob";
          xhr.onload = (event) => {
            const blob = xhr.response;
            const downloadURL = window.URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = downloadURL;
            a.download = proof;
            a.click();
            window.URL.revokeObjectURL(downloadURL);
          };
          xhr.onerror = (event) => {
            console.error("Error occurred while downloading the file.");
          };
          xhr.open("GET", url);
          xhr.send();
        }; // To download data directly in the browser, must configure the Cloud Storage bucket for cross-origin access (CORS).
      })
      .catch((error) => {
        console.error("Error retrieving image URL:", error);
      });

    this.setState({
      showProofModal: true,
    });
  }; // Retrieve and display proof image from Firebase Storage

  handleCloseProofModal = () => {
    document.getElementById("proofImage").src = "";
    this.setState({
      showProofModal: false,
    });
  };

  renderEditTripButton = (tripId) => {
    return (
      <button
        style={{
          width: "100%",
          background: "transparent",
          color: "#1DC7EA",
          border: "1.5px solid #1DC7EA",
          borderRadius: "100px",
          padding: "10px 0",
        }}
        onClick={() => this.handleShowEditModal(tripId)}
      >
        <i class="fas fa-pencil-alt" style={{ marginRight: "10px" }}></i>
        <span style={{ marginRight: "5px" }}>
          {localizationStrings.editTripBtn}
        </span>
      </button>
    );
  };

  handleShowEditModal = (tripId) => {
    this.setState({
      editTripId: tripId,
      showEditModal: true,
    });
  };

  handleCloseEditModal = () => {
    this.setState({
      editTripId: null,
      showEditModal: false,
    });
  };

  showNotification(msg, lvl, dismissal, allowDismiss) {
    let dismissalAllowed = false;

    if (allowDismiss === "") {
      dismissalAllowed = true;
    }
    //var level = lvl; // 'success', 'warning', 'error' or 'info'
    this.state._notificationSystem.addNotification({
      title: (
        <span
          data-notify="icon"
          className={
            lvl === "success"
              ? "pe-7s-check"
              : lvl === "error"
              ? "pe-7s-attention"
              : "pe-7s-bell"
          }
        ></span>
      ),
      message: <div>{msg}</div>,
      level: lvl,
      position: "tc",
      autoDismiss: dismissal,
      dismissible: dismissalAllowed,
    });
  }

  handleChangesSaved = () => {
    this.handleCloseEditModal();
    this.showNotification(`${localizationStrings.changesSaved}`, "success", 5);
  };

  handleChangesNotSaved = () => {
    this.showNotification(
      `${localizationStrings.changesNotSaved}`,
      "success",
      5
    );
  };

  renderBeginTripButton = (tripId) => {
    return (
      <button
        style={{
          width: "100%",
          background: "transparent",
          color: "green",
          border: "1.5px solid green",
          borderRadius: "100px",
          padding: "10px 0",
        }}
        onClick={() => this.handleBeginTrip(tripId)}
      >
        {localizationStrings.beginTripBtn}
      </button>
    );
  };

  handleBeginTrip = (tripId) => {
    const tripData = this.state.activeTrips.find(
      (trip) => trip.tripId === tripId
    );

    const tripRef = fire
      .database()
      .ref("activeTrip")
      .child(tripData.createdBy)
      .child(tripData.tripId);

    tripRef
      .update({
        Status: "Active",
        actualStart: Math.floor(Date.now() / 1000),
      })
      .then(() => {
        this.showNotification(
          `${localizationStrings.tripStarted}`,
          "success",
          5
        );
      })
      .catch((error) => {
        console.error("Error updating trip status: ", error);
        this.showNotification(
          `${localizationStrings.tripNotStarted}`,
          "error",
          5
        );
      });
  };

  createCustomSearchField = () => {
    return (
      <SearchField
        className="searchBar"
        placeholder={localizationStrings.searchPlaceholder}
        style={{ marginBottom: "15px" }}
      />
    );
  };

  createCustomDeleteButton = (onClick) => {
    return (
      <Button
        bsSize="large"
        id="retractableBtn"
        style={{ width: "100%", marginTop: "5px" }}
        onClick={onClick}
      >
        <i className="far fa-trash-alt" /> {localizationStrings.removeSelected}
      </Button>
    );
  };

  confirmDelete = (next) => {
    confirmAlert({
      title: localizationStrings.tripRemovalLabel,
      message: localizationStrings.tripRemovalMsg,
      buttons: [
        {
          label: localizationStrings.confirmBtn,
          onClick: () => next(),
        },
        {
          label: localizationStrings.cancelBtn,
          onClick: () => {
            return false;
          },
        },
      ],
    });
  };

  deleteTrip = () => {
    this.state.tripsSelected.forEach((tripId) => {
      fire
        .database()
        .ref("activeTrip")
        .child(auth.currentUser.uid)
        .child(tripId)
        .remove();
    });

    this.showNotification(`${localizationStrings.tripsRemoved}`, "success", 5);
  };

  componentWillUnmount() {
    if (auth.currentUser !== null && this._langCb) {
      fire
        .database()
        .ref("userSettings")
        .child(auth.currentUser.uid)
        .child("language")
        .off("value", this._langCb);
    }
  }

  render() {
    if (this.state.currentLanguage === "en") {
      localizationStrings.setLanguage("en");
    } else if (this.state.currentLanguage === "ja") {
      localizationStrings.setLanguage("ja");
    } else if (this.state.currentLanguage === "es") {
      localizationStrings.setLanguage("es");
    }

    const { markers, polylinePaths, livePolylinePaths } = this.state;
    const { activeTrips, selectedTripId } = this.state;
    console.log(activeTrips);

    const columnHover = (cell) => {
      return cell;
    };

    const centeredModalStyle = {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      minHeight: "100vh",
    };

    const selectRow = {
      // bgColor: "#eeeeee",
      mode: "checkbox",
      selected: this.state.tripsSelected,
      onSelect: (row, isSelected) => {
        const { tripsSelected } = this.state;

        const updatedSelectedRows = isSelected
          ? [...tripsSelected, row.tripId]
          : tripsSelected.filter((key) => key !== row.tripId);

        this.setState({ tripsSelected: updatedSelectedRows });
      },
      onSelectAll: (isSelected) => {
        const updatedSelectedRows = isSelected
          ? this.state.activeTrips.map((row) => row.tripId)
          : [];

        this.setState({ tripsSelected: updatedSelectedRows });
      },
    };

    return (
      <div style={{ paddingBottom: "80px" }}>
        <NotificationSystem ref="notificationSystem" style={style} />
        <style>
          {`
            .gm-style-iw-chr {
              display: none;
            }

            .gm-style-iw-d {
              margin-top: 25px;
              padding-left: 5.5px;
            }
          `}
        </style>
        <Modal
          show={this.state.showLocationsModal}
          onHide={() => this.handleCloseLocationsModal()}
          dialogClassName="modal-90w"
        >
          <Modal.Header closeButton>
            <Modal.Title>
              {localizationStrings.locationsHeader +
                (activeTrips.find(
                  (trip) => trip.tripId === this.state.selectedTripId
                )?.tripName
                  ? " - " +
                    activeTrips.find(
                      (trip) => trip.tripId === this.state.selectedTripId
                    )?.tripName
                  : "")}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div style={{ padding: "5px 25px 25px" }}>
              <div>
                <BootstrapTable
                  id="table"
                  pagination={true}
                  bordered={false}
                  data={this.state.locationsData}
                  options={{
                    sizePerPage: 8,
                    paginationSize: 10,
                    hideSizePerPage: true,
                    noDataText: localizationStrings.noDataTitle,
                  }}
                  // loading={this.state.loading}
                  className="locationWordWrap remarksWordWrap"
                  tableStyle={{
                    overflowX: "scroll",
                    tableLayout: "auto",
                    width: "100%",
                    display: "block",
                  }}
                >
                  <TableHeaderColumn
                    isKey
                    dataField="name"
                    editable={false}
                    columnTitle={columnHover}
                    thStyle={{ width: "37.5%" }}
                    tdStyle={{ width: "37.5%", height: "80px" }}
                  >
                    {localizationStrings.locationAddressHeader}
                  </TableHeaderColumn>
                  <TableHeaderColumn
                    dataSort
                    dataField="status"
                    dataFormat={this.displayStatus}
                    editable={false}
                    columnTitle={columnHover}
                    thStyle={{ width: "12.5%" }}
                    tdStyle={{ width: "12.5%" }}
                  >
                    {localizationStrings.statusHeader}
                  </TableHeaderColumn>
                  <TableHeaderColumn
                    dataField="remarks"
                    editable={false}
                    columnTitle={columnHover}
                    thStyle={{ width: "30%" }}
                    tdStyle={{ width: "30%" }}
                  >
                    {localizationStrings.remarksHeader}
                  </TableHeaderColumn>
                  <TableHeaderColumn
                    dataField="proof"
                    dataFormat={this.displayProof}
                    editable={false}
                    columnTitle={columnHover}
                    thStyle={{ width: "20%" }}
                    tdStyle={{ width: "20%" }}
                  >
                    {localizationStrings.proofHeader}
                  </TableHeaderColumn>
                </BootstrapTable>
              </div>
              <div
                style={{ width: "100%", height: "95vh", position: "relative" }}
              >
                <Map
                  google={this.props.google}
                  initialCenter={{ lat: 1.3521, lng: 103.8198 }}
                  center={this.state.mapCenter}
                  zoom={this.state.mapZoom}
                  gestureHandling="cooperative"
                  style={{
                    width: "100%",
                    height: "100%",
                    borderRadius: "5px",
                    boxShadow: "2px 3px 10px #B0B0B0",
                  }}
                  options={{
                    disableDefaultUI: true,
                    gestureHandling: "none",
                  }}
                >
                  {markers.map((markerData, index) => (
                    <Marker
                      key={index}
                      position={markerData.position}
                      title={markerData.title}
                      icon={markerData.icon}
                      onClick={() => this.handleMarkerClick(markerData)}
                      onMouseover={(e, marker) =>
                        this.onMarkerHover(markerData, marker)
                      }
                      onMouseout={this.onMarkerHoverOut}
                    />
                  ))}
                  {polylinePaths.map((path, index) => (
                    <Polyline
                      key={index}
                      path={path}
                      strokeColor="#FF0000"
                      strokeOpacity={1}
                      strokeWeight={3}
                      options={{
                        zIndex: 1,
                        icons: [
                          {
                            icon: {
                              path:
                                window.google.maps.SymbolPath
                                  .FORWARD_CLOSED_ARROW,
                              scale: 2.5,
                              strokeColor: "#FF0000",
                              fillColor: "#FF0000",
                              fillOpacity: 1,
                            },
                            offset: "100%",
                            repeat: "120px",
                          },
                        ],
                      }}
                    />
                  ))}
                  {livePolylinePaths.map((path, index) => (
                    <Polyline
                      key={index}
                      path={path}
                      strokeColor="#FFA500"
                      strokeOpacity={1}
                      strokeWeight={3}
                      options={{
                        zIndex: 2,
                        icons: [
                          {
                            icon: {
                              path:
                                window.google.maps.SymbolPath
                                  .FORWARD_CLOSED_ARROW,
                              scale: 2.5,
                              strokeColor: "#FFA500",
                              fillColor: "#FFA500",
                              fillOpacity: 1,
                            },
                            offset: "100%",
                            repeat: "100px",
                          },
                        ],
                      }}
                    />
                  ))}
                  <InfoWindow
                    marker={this.state.activeMarker}
                    visible={this.state.showingUnlockInfoWindow}
                    disableAutoPan={true}
                  >
                    <div>
                      <p style={{ textAlign: "center", marginBottom: "20px" }}>
                        {localizationStrings.unlockPointHeader}
                      </p>
                      <p style={{ fontSize: "14px" }}>
                        {localizationStrings.lock}{" "}
                        <span style={{ marginLeft: "5px", color: "grey" }}>
                          {this.state.selectedPlace.lock
                            ? this.state.selectedPlace.lock.Name +
                              " (" +
                              this.state.selectedPlace.lock.ip45SerialNumber +
                              ")"
                            : "-"}
                        </span>
                      </p>
                      <p style={{ fontSize: "14px" }}>
                        {localizationStrings.unlockedBy}{" "}
                        <span style={{ marginLeft: "5px", color: "grey" }}>
                          {this.state.selectedPlace.data
                            ? this.state.selectedPlace.data.userEmail
                            : "-"}
                        </span>
                      </p>
                      <p style={{ fontSize: "14px" }}>
                        {localizationStrings.unlockedOn}{" "}
                        <span style={{ marginLeft: "5px", color: "grey" }}>
                          {this.state.selectedPlace.data
                            ? this.formatDate(
                                this.state.selectedPlace.data.time
                              )
                            : "-"}
                        </span>
                      </p>
                      <p style={{ fontSize: "14px" }}>
                        {localizationStrings.location}{" "}
                        <span style={{ marginLeft: "5px", color: "grey" }}>
                          {this.state.selectedPlace.data
                            ? this.state.selectedPlace.data.Placemark
                            : "-"}
                        </span>
                      </p>
                    </div>
                  </InfoWindow>
                  <InfoWindow
                    marker={this.state.activeMarker}
                    visible={this.state.showingLocationInfoWindow}
                    disableAutoPan={true}
                  >
                    <div>
                      <p style={{ textAlign: "center", marginBottom: "20px" }}>
                        {localizationStrings.destinationPointHeader}
                      </p>
                      <p style={{ fontSize: "14px" }}>
                        {localizationStrings.location}{" "}
                        <span style={{ marginLeft: "5px", color: "grey" }}>
                          {this.state.selectedPlace.data
                            ? this.state.selectedPlace.data.name
                            : "-"}
                        </span>
                      </p>
                      <p style={{ fontSize: "14px" }}>
                        {localizationStrings.statusLabel}
                        <span
                          style={{
                            marginLeft: "5px",
                            color: this.state.selectedPlace.data
                              ? this.state.selectedPlace.data.status ===
                                "Completed"
                                ? "green"
                                : this.state.selectedPlace.data.status ===
                                  "Pending Arrival"
                                ? "red"
                                : this.state.selectedPlace.data.status ===
                                  "Skipped"
                                ? "orange"
                                : "grey"
                              : "grey",
                          }}
                        >
                          {this.state.selectedPlace.data
                            ? this.state.selectedPlace.data.status ===
                              "Completed"
                              ? localizationStrings.completedStatus
                              : this.state.selectedPlace.data.status ===
                                "Pending Arrival"
                              ? localizationStrings.pendingArrivalStatus
                              : this.state.selectedPlace.data.status ===
                                "Skipped"
                              ? localizationStrings.skippedStatus
                              : this.state.selectedPlace.data.status
                            : "-"}
                        </span>
                      </p>
                      <p style={{ fontSize: "14px" }}>
                        {localizationStrings.remarksLabel}{" "}
                        <span style={{ marginLeft: "5px", color: "grey" }}>
                          {this.state.selectedPlace.data
                            ? this.state.selectedPlace.data.remarks
                            : "-"}
                        </span>
                      </p>
                    </div>
                  </InfoWindow>
                </Map>
              </div>
            </div>
          </Modal.Body>
        </Modal>
        <Modal
          show={this.state.showLockActivityModal}
          onHide={() => this.handleCloseLockActivityModal()}
          dialogClassName="modal-90w"
        >
          <Modal.Header closeButton>
            <Modal.Title>
              {localizationStrings.lockActivityHeader +
                (activeTrips.find(
                  (trip) => trip.tripId === this.state.selectedTripId
                )?.tripName
                  ? " - " +
                    activeTrips.find(
                      (trip) => trip.tripId === this.state.selectedTripId
                    )?.tripName
                  : "")}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div style={{ padding: "5px 25px 25px" }}>
              <div>
                <BootstrapTable
                  id="table"
                  pagination={true}
                  bordered={false}
                  data={this.state.lockActivity}
                  options={{
                    sizePerPage: 8,
                    paginationSize: 10,
                    hideSizePerPage: true,
                    noDataText: localizationStrings.noDataTitle,
                  }}
                  // loading={this.state.loading}
                  className="locationWordWrap2"
                  tableStyle={{
                    overflowX: "scroll",
                    tableLayout: "auto",
                    width: "100%",
                    display: "block",
                  }}
                >
                  <TableHeaderColumn
                    isKey
                    dataSort
                    dataField="lock"
                    editable={false}
                    columnTitle={columnHover}
                    thStyle={{ width: "15%" }}
                    tdStyle={{ width: "15%", height: "80px" }}
                  >
                    Lock
                  </TableHeaderColumn>
                  <TableHeaderColumn
                    dataSort
                    dataField="lockedStatus"
                    dataFormat={this.displayStatus}
                    editable={false}
                    columnTitle={columnHover}
                    thStyle={{ width: "15%" }}
                    tdStyle={{ width: "15%" }}
                  >
                    Lock Status
                  </TableHeaderColumn>
                  <TableHeaderColumn
                    dataSort
                    dataField="userEmail"
                    editable={false}
                    columnTitle={columnHover}
                    thStyle={{ width: "20%" }}
                    tdStyle={{ width: "20%" }}
                  >
                    Unlocked By
                  </TableHeaderColumn>
                  <TableHeaderColumn
                    dataSort
                    dataField="time"
                    dataFormat={this.formatUnixTimestampDisplayDate}
                    editable={false}
                    thStyle={{ width: "20%" }}
                    tdStyle={{ width: "20%" }}
                  >
                    Unlocked On
                  </TableHeaderColumn>
                  <TableHeaderColumn
                    dataField="Placemark"
                    editable={false}
                    columnTitle={columnHover}
                    thStyle={{ width: "30%" }}
                    tdStyle={{ width: "30%" }}
                  >
                    Location/Address
                  </TableHeaderColumn>
                </BootstrapTable>
              </div>
              <div
                style={{ width: "100%", height: "95vh", position: "relative" }}
              >
                <Map
                  google={this.props.google}
                  initialCenter={{ lat: 1.3521, lng: 103.8198 }}
                  center={this.state.mapCenter}
                  zoom={this.state.mapZoom}
                  gestureHandling="cooperative"
                  style={{
                    width: "100%",
                    height: "100%",
                    borderRadius: "5px",
                    boxShadow: "2px 3px 10px #B0B0B0",
                  }}
                  options={{
                    disableDefaultUI: true,
                    gestureHandling: "none",
                  }}
                >
                  {markers.map((markerData, index) => (
                    <Marker
                      key={index}
                      position={markerData.position}
                      title={markerData.title}
                      icon={markerData.icon}
                      onClick={() => this.handleMarkerClick(markerData)}
                      onMouseover={(e, marker) =>
                        this.onMarkerHover(markerData, marker)
                      }
                      onMouseout={this.onMarkerHoverOut}
                    />
                  ))}
                  {polylinePaths.map((path, index) => (
                    <Polyline
                      key={index}
                      path={path}
                      strokeColor="#FF0000"
                      strokeOpacity={1}
                      strokeWeight={3}
                      options={{
                        zIndex: 1,
                        icons: [
                          {
                            icon: {
                              path:
                                window.google.maps.SymbolPath
                                  .FORWARD_CLOSED_ARROW,
                              scale: 2.5,
                              strokeColor: "#FF0000",
                              fillColor: "#FF0000",
                              fillOpacity: 1,
                            },
                            offset: "100%",
                            repeat: "120px",
                          },
                        ],
                      }}
                    />
                  ))}
                  {livePolylinePaths.map((path, index) => (
                    <Polyline
                      key={index}
                      path={path}
                      strokeColor="#FFA500"
                      strokeOpacity={1}
                      strokeWeight={3}
                      options={{
                        zIndex: 2,
                        icons: [
                          {
                            icon: {
                              path:
                                window.google.maps.SymbolPath
                                  .FORWARD_CLOSED_ARROW,
                              scale: 2.5,
                              strokeColor: "#FFA500",
                              fillColor: "#FFA500",
                              fillOpacity: 1,
                            },
                            offset: "100%",
                            repeat: "100px",
                          },
                        ],
                      }}
                    />
                  ))}
                  <InfoWindow
                    marker={this.state.activeMarker}
                    visible={this.state.showingUnlockInfoWindow}
                    disableAutoPan={true}
                  >
                    <div>
                      <p style={{ textAlign: "center", marginBottom: "20px" }}>
                        {localizationStrings.unlockPointHeader}
                      </p>
                      <p style={{ fontSize: "14px" }}>
                        {localizationStrings.lock}{" "}
                        <span style={{ marginLeft: "5px", color: "grey" }}>
                          {this.state.selectedPlace.lock
                            ? this.state.selectedPlace.lock.Name +
                              " (" +
                              this.state.selectedPlace.lock.ip45SerialNumber +
                              ")"
                            : "-"}
                        </span>
                      </p>
                      <p style={{ fontSize: "14px" }}>
                        {localizationStrings.unlockedBy}{" "}
                        <span style={{ marginLeft: "5px", color: "grey" }}>
                          {this.state.selectedPlace.data
                            ? this.state.selectedPlace.data.userEmail
                            : "-"}
                        </span>
                      </p>
                      <p style={{ fontSize: "14px" }}>
                        {localizationStrings.unlockedOn}{" "}
                        <span style={{ marginLeft: "5px", color: "grey" }}>
                          {this.state.selectedPlace.data
                            ? this.formatDate(
                                this.state.selectedPlace.data.time
                              )
                            : "-"}
                        </span>
                      </p>
                      <p style={{ fontSize: "14px" }}>
                        {localizationStrings.location}{" "}
                        <span style={{ marginLeft: "5px", color: "grey" }}>
                          {this.state.selectedPlace.data
                            ? this.state.selectedPlace.data.Placemark
                            : "-"}
                        </span>
                      </p>
                    </div>
                  </InfoWindow>
                  <InfoWindow
                    marker={this.state.activeMarker}
                    visible={this.state.showingLocationInfoWindow}
                    disableAutoPan={true}
                  >
                    <div>
                      <p style={{ textAlign: "center", marginBottom: "20px" }}>
                        {localizationStrings.destinationPointHeader}
                      </p>
                      <p style={{ fontSize: "14px" }}>
                        {localizationStrings.location}{" "}
                        <span style={{ marginLeft: "5px", color: "grey" }}>
                          {this.state.selectedPlace.data
                            ? this.state.selectedPlace.data.name
                            : "-"}
                        </span>
                      </p>
                      <p style={{ fontSize: "14px" }}>
                        {localizationStrings.statusLabel}
                        <span
                          style={{
                            marginLeft: "5px",
                            color: this.state.selectedPlace.data
                              ? this.state.selectedPlace.data.status ===
                                "Completed"
                                ? "green"
                                : this.state.selectedPlace.data.status ===
                                  "Pending Arrival"
                                ? "red"
                                : this.state.selectedPlace.data.status ===
                                  "Skipped"
                                ? "orange"
                                : "grey"
                              : "grey",
                          }}
                        >
                          {this.state.selectedPlace.data
                            ? this.state.selectedPlace.data.status ===
                              "Completed"
                              ? localizationStrings.completedStatus
                              : this.state.selectedPlace.data.status ===
                                "Pending Arrival"
                              ? localizationStrings.pendingArrivalStatus
                              : this.state.selectedPlace.data.status ===
                                "Skipped"
                              ? localizationStrings.skippedStatus
                              : this.state.selectedPlace.data.status
                            : "-"}
                        </span>
                      </p>
                      <p style={{ fontSize: "14px" }}>
                        {localizationStrings.remarksLabel}{" "}
                        <span style={{ marginLeft: "5px", color: "grey" }}>
                          {this.state.selectedPlace.data
                            ? this.state.selectedPlace.data.remarks
                            : "-"}
                        </span>
                      </p>
                    </div>
                  </InfoWindow>
                </Map>
              </div>
            </div>
          </Modal.Body>
        </Modal>
        <Modal
          show={this.state.showProofModal}
          onHide={() => this.handleCloseProofModal()}
          dialogClassName="modal-50w"
          style={centeredModalStyle}
        >
          <Modal.Header closeButton>
            <Modal.Title>{localizationStrings.proofOfCompletion}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <img
                id="proofImage"
                src=""
                alt="Proof Image"
                style={{
                  width: "100%",
                  height: "auto",
                  maxHeight: "70vh",
                  objectFit: "contain",
                  borderRadius: "5px",
                }}
              />
              <div style={{ display: "flex", gap: "50px" }}>
                <button
                  id="proofNewTab"
                  style={{
                    background: "transparent",
                    color: "#1DC7EA",
                    border: "1.5px solid #1DC7EA",
                    borderRadius: "100px",
                    padding: "10px 20px",
                    marginTop: "15px",
                    minWidth: "250px",
                  }}
                >
                  <i
                    class="fas fa-external-link-alt"
                    style={{ marginRight: "10px" }}
                  ></i>{" "}
                  {localizationStrings.openInNewTab}
                </button>
                <button
                  id="proofDownload"
                  style={{
                    background: "transparent",
                    color: "#1DC7EA",
                    border: "1.5px solid #1DC7EA",
                    borderRadius: "100px",
                    padding: "10px 20px",
                    marginTop: "15px",
                    minWidth: "250px",
                  }}
                >
                  <i
                    class="fas fa-download"
                    style={{ marginRight: "10px" }}
                  ></i>{" "}
                  {localizationStrings.downloadImage}
                </button>
              </div>
            </div>
          </Modal.Body>
        </Modal>
        <Modal
          show={this.state.showMarkerModal}
          onHide={() => this.handleCloseMarkerModal()}
          dialogClassName="modal-50w"
          style={centeredModalStyle}
        >
          <Modal.Header closeButton>
            <Modal.Title>{localizationStrings.unlockInfoHeader}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div>
              <div style={{ display: "flex" }}>
                <p style={{ width: "25%" }}>
                  {localizationStrings.lockUnlocked}
                </p>
                <p style={{ width: "75%", color: "grey" }}>
                  {this.state.selectedMarker
                    ? this.state.selectedMarker.lock.Name +
                      " (" +
                      this.state.selectedMarker.lock.ip45SerialNumber +
                      ")"
                    : "-"}
                </p>
              </div>
              <div style={{ display: "flex" }}>
                <p style={{ width: "25%" }}>{localizationStrings.unlockedBy}</p>
                <p style={{ width: "75%", color: "grey" }}>
                  {this.state.selectedMarker
                    ? this.state.selectedMarker.data.userEmail
                    : "-"}
                </p>
              </div>
              <div style={{ display: "flex" }}>
                <p style={{ width: "25%" }}>{localizationStrings.unlockedOn}</p>
                <p style={{ width: "75%", color: "grey" }}>
                  {this.state.selectedMarker
                    ? this.formatDate(this.state.selectedMarker.data.time)
                    : "-"}
                </p>
              </div>
              <div style={{ display: "flex" }}>
                <p style={{ width: "25%" }}>
                  {localizationStrings.unlockLocation}
                </p>
                <p style={{ width: "75%", color: "grey" }}>
                  {this.state.selectedMarker
                    ? this.state.selectedMarker.data.Placemark
                    : "-"}
                </p>
              </div>
            </div>
          </Modal.Body>
        </Modal>
        <Modal
          show={this.state.showMarkerModal2}
          onHide={() => this.handleCloseMarkerModal()}
          dialogClassName="modal-50w"
          style={centeredModalStyle}
        >
          <Modal.Header closeButton>
            <Modal.Title>
              {localizationStrings.destinationInfoHeader}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div>
              <div style={{ display: "flex" }}>
                <p style={{ width: "20%" }}>{localizationStrings.location}</p>
                <p style={{ width: "80%", color: "grey" }}>
                  {this.state.selectedMarker2
                    ? this.state.selectedMarker2.data.name
                    : "-"}
                </p>
              </div>
              <div style={{ display: "flex" }}>
                <p style={{ width: "20%" }}>
                  {localizationStrings.statusLabel}
                </p>
                <p
                  style={{
                    width: "80%",
                    color: this.state.selectedMarker2
                      ? this.state.selectedMarker2.data.status === "Completed"
                        ? "green"
                        : this.state.selectedMarker2.data.status ===
                          "Pending Arrival"
                        ? "red"
                        : this.state.selectedMarker2.data.status === "Skipped"
                        ? "orange"
                        : "grey"
                      : "grey",
                  }}
                >
                  {this.state.selectedMarker2
                    ? this.state.selectedMarker2.data.status
                    : "-"}
                </p>
              </div>
              <div style={{ display: "flex" }}>
                <p style={{ width: "20%" }}>
                  {localizationStrings.remarksLabel}
                </p>
                <p style={{ width: "80%", color: "grey" }}>
                  {this.state.selectedMarker2
                    ? this.state.selectedMarker2.data.remarks
                    : "-"}
                </p>
              </div>
            </div>
          </Modal.Body>
        </Modal>
        <Modal
          show={this.state.showEditModal}
          onHide={this.handleCloseEditModal}
          dialogClassName="modal-50w"
        >
          <Modal.Header closeButton>
            <Modal.Title>
              {localizationStrings.editTripBtn +
                (activeTrips.find(
                  (trip) => trip.tripId === this.state.editTripId
                )?.tripName
                  ? " - " +
                    activeTrips.find(
                      (trip) => trip.tripId === this.state.editTripId
                    )?.tripName
                  : "")}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <EditTrip
              tripId={this.state.editTripId}
              onSave={this.handleChangesSaved}
              onFail={this.handleChangesNotSaved}
            />
          </Modal.Body>
        </Modal>
        <div style={{ width: "100%", marginLeft: "0px", marginRight: "auto" }}>
          <h3 style={{ margin: "30px 0 30px" }}>
            {localizationStrings.inactiveTripsHeader}
          </h3>
          <BootstrapTable
            id="table"
            pagination={true}
            bordered={false}
            search
            selectRow={selectRow}
            deleteRow
            data={this.state.activeTrips.sort(
              (a, b) => new Date(b.createdOn) - new Date(a.createdOn)
            )}
            options={{
              paginationSize: 10,
              hideSizePerPage: true,
              noDataText: localizationStrings.noDataTitle,
              searchField: this.createCustomSearchField,
              deleteBtn: this.createCustomDeleteButton,
              handleConfirmDeleteRow: this.confirmDelete,
              afterDeleteRow: this.deleteTrip,
            }}
            // loading={this.state.loading}
            className="tripNameWordWrap trackedLocksWordWrap horizontalScrollFade stickyColumn"
            tableStyle={{
              overflowX: "scroll",
              tableLayout: "auto",
              width: "100%",
              display: "block",
            }}
          >
            <TableHeaderColumn dataField="tripId" isKey hidden />
            <TableHeaderColumn
              dataSort
              dataField="tripName"
              editable={false}
              columnTitle={columnHover}
              thStyle={{ width: "200px" }}
              tdStyle={{ width: "200px", height: "80px" }}
            >
              {localizationStrings.tripNameHeader}
            </TableHeaderColumn>
            <TableHeaderColumn
              dataSort
              dataField="PICEmail"
              editable={false}
              columnTitle={columnHover}
              thStyle={{ width: "225px" }}
              tdStyle={{ width: "225px" }}
            >
              {localizationStrings.PICHeader}
            </TableHeaderColumn>
            <TableHeaderColumn
              dataSort
              dataField="lockSelected"
              dataFormat={this.displayTrackedLocks}
              editable={false}
              thStyle={{ width: "225px" }}
              tdStyle={{ width: "225px" }}
            >
              {localizationStrings.trackedLocksHeader}
            </TableHeaderColumn>
            <TableHeaderColumn
              dataSort
              dataField="datestart"
              dataFormat={this.formatDisplayDate}
              editable={false}
              thStyle={{ width: "200px" }}
              tdStyle={{ width: "200px" }}
            >
              {localizationStrings.schedStartHeader}
            </TableHeaderColumn>
            <TableHeaderColumn
              dataSort
              dataField="endDate"
              dataFormat={this.formatDisplayDate}
              editable={false}
              thStyle={{ width: "200px" }}
              tdStyle={{ width: "200px" }}
            >
              {localizationStrings.schedEndHeader}
            </TableHeaderColumn>
            <TableHeaderColumn
              dataField="tripId"
              dataFormat={this.renderLocationsButton}
              editable={false}
              thStyle={{ width: "200px" }}
              tdStyle={{ width: "200px" }}
            >
              {localizationStrings.locationsHeader}
            </TableHeaderColumn>
            <TableHeaderColumn
              dataField="tripId"
              dataFormat={this.renderEditTripButton}
              editable={false}
              thStyle={{ width: "200px" }}
              tdStyle={{ width: "200px" }}
            >
              {localizationStrings.editTripHeader}
            </TableHeaderColumn>
            <TableHeaderColumn
              dataField="tripId"
              dataFormat={this.renderBeginTripButton}
              editable={false}
              thStyle={{ width: "200px" }}
              tdStyle={{ width: "200px" }}
            >
              {localizationStrings.beginTripHeader}
            </TableHeaderColumn>
          </BootstrapTable>
        </div>
      </div>
    );
  }
}

export default GoogleApiWrapper({
  apiKey: process.env.REACT_APP_GOOGLE_MAP_API_KEY,
})(MapViewSection);
